'use client'
import { usePathname } from "next/navigation";
import { ReactNode, useEffect, useState } from "react";


export const SkipToContentProvider = (props: {
  children: ReactNode
}) => {
  const pathname = usePathname()
  const [markerExists, setMarkerExists] = useState(false);

  useEffect(() => {
    const body = document.body;
    
    // Temporarily make the body focusable
    body.setAttribute('tabindex', '-1');  
    body.focus();

    // Clean up: Remove the tabindex after focusing
    const removeTabIndex = () => {
      body.removeAttribute('tabindex');
    };

    // Use a timeout to ensure the tabindex is removed after focus
    const timeoutId = setTimeout(removeTabIndex, 0);

    // Cleanup function to clear timeout
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const marker = document.getElementById('#toContent');
      const exists = !!marker;
      setMarkerExists(exists);

      observer.observe(document.body, { childList: true, subtree: true });

      return () => observer.disconnect();
    });
  })

  return <>
    {markerExists && (
      <a href="#toContent" className="sr-only focus:not-sr-only">Skip to content</a>
    )}
    {props.children}
  </>
}

export const SkipToContentMarker = () => {
  return <a id="toContent" />
}